// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/collection/collection_service.proto (package api.v1.collection, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Pagination, PaginationRequest } from "../common/pagination_pb";
import { file_v1_common_pagination } from "../common/pagination_pb";
import type { LatLng } from "../../google/type/latlng_pb";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/collection/collection_service.proto.
 */
export const file_v1_collection_collection_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_google_protobuf_timestamp, file_v1_common_pagination, file_google_type_latlng]);

/**
 * @generated from message api.v1.collection.Collection
 */
export type Collection = Message<"api.v1.collection.Collection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: api.v1.collection.CollectionVisibility visibility = 5;
   */
  visibility: CollectionVisibility;

  /**
   * @generated from field: int32 item_count = 6;
   */
  itemCount: number;

  /**
   * First item's image for thumbnails
   *
   * @generated from field: optional string preview_image_url = 7;
   */
  previewImageUrl?: string;

  /**
   * For "Save to Profile" collection
   *
   * @generated from field: optional bool is_default = 8;
   */
  isDefault?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.collection.Collection.
 * Use `create(CollectionSchema)` to create a new message.
 */
export const CollectionSchema: GenMessage<Collection> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 0);

/**
 * @generated from message api.v1.collection.SavedItem
 */
export type SavedItem = Message<"api.v1.collection.SavedItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 3;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * @generated from field: string collection_id = 5;
   */
  collectionId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api.v1.collection.SavedItem.
 * Use `create(SavedItemSchema)` to create a new message.
 */
export const SavedItemSchema: GenMessage<SavedItem> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 1);

/**
 * @generated from message api.v1.collection.SavedItemDetails
 */
export type SavedItemDetails = Message<"api.v1.collection.SavedItemDetails"> & {
  /**
   * @generated from field: api.v1.collection.SavedItem item = 1;
   */
  item?: SavedItem;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string image_url = 4;
   */
  imageUrl?: string;

  /**
   * @generated from field: optional string org_name = 5;
   */
  orgName?: string;

  /**
   * @generated from field: optional string org_id = 6;
   */
  orgId?: string;

  /**
   * @generated from field: optional string org_slug = 7;
   */
  orgSlug?: string;

  /**
   * For events only
   *
   * @generated from field: optional google.protobuf.Timestamp start_date = 8;
   */
  startDate?: Timestamp;

  /**
   * For events only
   *
   * @generated from field: optional google.protobuf.Timestamp end_date = 9;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: optional google.type.LatLng location = 10;
   */
  location?: LatLng;

  /**
   * @generated from field: optional float distance_km = 11;
   */
  distanceKm?: number;
};

/**
 * Describes the message api.v1.collection.SavedItemDetails.
 * Use `create(SavedItemDetailsSchema)` to create a new message.
 */
export const SavedItemDetailsSchema: GenMessage<SavedItemDetails> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 2);

/**
 * @generated from message api.v1.collection.CreateCollectionRequest
 */
export type CreateCollectionRequest = Message<"api.v1.collection.CreateCollectionRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: api.v1.collection.CollectionVisibility visibility = 3;
   */
  visibility: CollectionVisibility;
};

/**
 * Describes the message api.v1.collection.CreateCollectionRequest.
 * Use `create(CreateCollectionRequestSchema)` to create a new message.
 */
export const CreateCollectionRequestSchema: GenMessage<CreateCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 3);

/**
 * @generated from message api.v1.collection.CreateCollectionResponse
 */
export type CreateCollectionResponse = Message<"api.v1.collection.CreateCollectionResponse"> & {
  /**
   * @generated from field: api.v1.collection.Collection collection = 1;
   */
  collection?: Collection;
};

/**
 * Describes the message api.v1.collection.CreateCollectionResponse.
 * Use `create(CreateCollectionResponseSchema)` to create a new message.
 */
export const CreateCollectionResponseSchema: GenMessage<CreateCollectionResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 4);

/**
 * @generated from message api.v1.collection.GetCollectionRequest
 */
export type GetCollectionRequest = Message<"api.v1.collection.GetCollectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.collection.GetCollectionRequest.
 * Use `create(GetCollectionRequestSchema)` to create a new message.
 */
export const GetCollectionRequestSchema: GenMessage<GetCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 5);

/**
 * @generated from message api.v1.collection.UpdateCollectionRequest
 */
export type UpdateCollectionRequest = Message<"api.v1.collection.UpdateCollectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: api.v1.collection.CollectionVisibility visibility = 4;
   */
  visibility: CollectionVisibility;
};

/**
 * Describes the message api.v1.collection.UpdateCollectionRequest.
 * Use `create(UpdateCollectionRequestSchema)` to create a new message.
 */
export const UpdateCollectionRequestSchema: GenMessage<UpdateCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 6);

/**
 * @generated from message api.v1.collection.DeleteCollectionRequest
 */
export type DeleteCollectionRequest = Message<"api.v1.collection.DeleteCollectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.collection.DeleteCollectionRequest.
 * Use `create(DeleteCollectionRequestSchema)` to create a new message.
 */
export const DeleteCollectionRequestSchema: GenMessage<DeleteCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 7);

/**
 * @generated from message api.v1.collection.ListCollectionsRequest
 */
export type ListCollectionsRequest = Message<"api.v1.collection.ListCollectionsRequest"> & {
  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.collection.ListCollectionsRequest.
 * Use `create(ListCollectionsRequestSchema)` to create a new message.
 */
export const ListCollectionsRequestSchema: GenMessage<ListCollectionsRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 8);

/**
 * @generated from message api.v1.collection.ListCollectionsResponse
 */
export type ListCollectionsResponse = Message<"api.v1.collection.ListCollectionsResponse"> & {
  /**
   * @generated from field: repeated api.v1.collection.Collection collections = 1;
   */
  collections: Collection[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.v1.collection.ListCollectionsResponse.
 * Use `create(ListCollectionsResponseSchema)` to create a new message.
 */
export const ListCollectionsResponseSchema: GenMessage<ListCollectionsResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 9);

/**
 * @generated from message api.v1.collection.AddItemToCollectionRequest
 */
export type AddItemToCollectionRequest = Message<"api.v1.collection.AddItemToCollectionRequest"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.AddItemToCollectionRequest.
 * Use `create(AddItemToCollectionRequestSchema)` to create a new message.
 */
export const AddItemToCollectionRequestSchema: GenMessage<AddItemToCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 10);

/**
 * @generated from message api.v1.collection.AddItemToCollectionsRequest
 */
export type AddItemToCollectionsRequest = Message<"api.v1.collection.AddItemToCollectionsRequest"> & {
  /**
   * Empty array saves to virtual "All Saved"
   *
   * @generated from field: repeated string collection_ids = 1;
   */
  collectionIds: string[];

  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.AddItemToCollectionsRequest.
 * Use `create(AddItemToCollectionsRequestSchema)` to create a new message.
 */
export const AddItemToCollectionsRequestSchema: GenMessage<AddItemToCollectionsRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 11);

/**
 * @generated from message api.v1.collection.SaveItemRequest
 */
export type SaveItemRequest = Message<"api.v1.collection.SaveItemRequest"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.SaveItemRequest.
 * Use `create(SaveItemRequestSchema)` to create a new message.
 */
export const SaveItemRequestSchema: GenMessage<SaveItemRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 12);

/**
 * @generated from message api.v1.collection.UnsaveItemRequest
 */
export type UnsaveItemRequest = Message<"api.v1.collection.UnsaveItemRequest"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.UnsaveItemRequest.
 * Use `create(UnsaveItemRequestSchema)` to create a new message.
 */
export const UnsaveItemRequestSchema: GenMessage<UnsaveItemRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 13);

/**
 * @generated from message api.v1.collection.RemoveItemFromCollectionRequest
 */
export type RemoveItemFromCollectionRequest = Message<"api.v1.collection.RemoveItemFromCollectionRequest"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.RemoveItemFromCollectionRequest.
 * Use `create(RemoveItemFromCollectionRequestSchema)` to create a new message.
 */
export const RemoveItemFromCollectionRequestSchema: GenMessage<RemoveItemFromCollectionRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 14);

/**
 * @generated from message api.v1.collection.GetCollectionItemsRequest
 */
export type GetCollectionItemsRequest = Message<"api.v1.collection.GetCollectionItemsRequest"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.collection.GetCollectionItemsRequest.
 * Use `create(GetCollectionItemsRequestSchema)` to create a new message.
 */
export const GetCollectionItemsRequestSchema: GenMessage<GetCollectionItemsRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 15);

/**
 * @generated from message api.v1.collection.GetAllSavedItemsRequest
 */
export type GetAllSavedItemsRequest = Message<"api.v1.collection.GetAllSavedItemsRequest"> & {
  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.collection.GetAllSavedItemsRequest.
 * Use `create(GetAllSavedItemsRequestSchema)` to create a new message.
 */
export const GetAllSavedItemsRequestSchema: GenMessage<GetAllSavedItemsRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 16);

/**
 * @generated from message api.v1.collection.GetCollectionItemsResponse
 */
export type GetCollectionItemsResponse = Message<"api.v1.collection.GetCollectionItemsResponse"> & {
  /**
   * @generated from field: repeated api.v1.collection.SavedItemDetails items = 1;
   */
  items: SavedItemDetails[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.v1.collection.GetCollectionItemsResponse.
 * Use `create(GetCollectionItemsResponseSchema)` to create a new message.
 */
export const GetCollectionItemsResponseSchema: GenMessage<GetCollectionItemsResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 17);

/**
 * @generated from message api.v1.collection.IsSavedRequest
 */
export type IsSavedRequest = Message<"api.v1.collection.IsSavedRequest"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.IsSavedRequest.
 * Use `create(IsSavedRequestSchema)` to create a new message.
 */
export const IsSavedRequestSchema: GenMessage<IsSavedRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 18);

/**
 * @generated from message api.v1.collection.IsSavedResponse
 */
export type IsSavedResponse = Message<"api.v1.collection.IsSavedResponse"> & {
  /**
   * @generated from field: bool is_saved = 1;
   */
  isSaved: boolean;
};

/**
 * Describes the message api.v1.collection.IsSavedResponse.
 * Use `create(IsSavedResponseSchema)` to create a new message.
 */
export const IsSavedResponseSchema: GenMessage<IsSavedResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 19);

/**
 * @generated from message api.v1.collection.CollectionWithSaveStatus
 */
export type CollectionWithSaveStatus = Message<"api.v1.collection.CollectionWithSaveStatus"> & {
  /**
   * @generated from field: api.v1.collection.Collection collection = 1;
   */
  collection?: Collection;

  /**
   * True if the item is already in this collection
   *
   * @generated from field: bool is_saved = 2;
   */
  isSaved: boolean;
};

/**
 * Describes the message api.v1.collection.CollectionWithSaveStatus.
 * Use `create(CollectionWithSaveStatusSchema)` to create a new message.
 */
export const CollectionWithSaveStatusSchema: GenMessage<CollectionWithSaveStatus> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 20);

/**
 * @generated from message api.v1.collection.GetUserCollectionsWithSaveStatusRequest
 */
export type GetUserCollectionsWithSaveStatusRequest = Message<"api.v1.collection.GetUserCollectionsWithSaveStatusRequest"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.GetUserCollectionsWithSaveStatusRequest.
 * Use `create(GetUserCollectionsWithSaveStatusRequestSchema)` to create a new message.
 */
export const GetUserCollectionsWithSaveStatusRequestSchema: GenMessage<GetUserCollectionsWithSaveStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 21);

/**
 * @generated from message api.v1.collection.GetUserCollectionsWithSaveStatusResponse
 */
export type GetUserCollectionsWithSaveStatusResponse = Message<"api.v1.collection.GetUserCollectionsWithSaveStatusResponse"> & {
  /**
   * @generated from field: repeated api.v1.collection.CollectionWithSaveStatus collections = 1;
   */
  collections: CollectionWithSaveStatus[];

  /**
   * True if item is saved in any collection
   *
   * @generated from field: bool is_saved_anywhere = 2;
   */
  isSavedAnywhere: boolean;
};

/**
 * Describes the message api.v1.collection.GetUserCollectionsWithSaveStatusResponse.
 * Use `create(GetUserCollectionsWithSaveStatusResponseSchema)` to create a new message.
 */
export const GetUserCollectionsWithSaveStatusResponseSchema: GenMessage<GetUserCollectionsWithSaveStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 22);

/**
 * @generated from message api.v1.collection.SaveStatusItem
 */
export type SaveStatusItem = Message<"api.v1.collection.SaveStatusItem"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.collection.SaveStatusItem.
 * Use `create(SaveStatusItemSchema)` to create a new message.
 */
export const SaveStatusItemSchema: GenMessage<SaveStatusItem> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 23);

/**
 * @generated from message api.v1.collection.ItemSaveStatus
 */
export type ItemSaveStatus = Message<"api.v1.collection.ItemSaveStatus"> & {
  /**
   * @generated from field: api.v1.collection.EntityType entity_type = 1;
   */
  entityType: EntityType;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: bool is_saved = 3;
   */
  isSaved: boolean;

  /**
   * @generated from field: optional string primary_collection_id = 4;
   */
  primaryCollectionId?: string;
};

/**
 * Describes the message api.v1.collection.ItemSaveStatus.
 * Use `create(ItemSaveStatusSchema)` to create a new message.
 */
export const ItemSaveStatusSchema: GenMessage<ItemSaveStatus> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 24);

/**
 * @generated from message api.v1.collection.CheckMultipleSaveStatusRequest
 */
export type CheckMultipleSaveStatusRequest = Message<"api.v1.collection.CheckMultipleSaveStatusRequest"> & {
  /**
   * @generated from field: repeated api.v1.collection.SaveStatusItem items = 1;
   */
  items: SaveStatusItem[];
};

/**
 * Describes the message api.v1.collection.CheckMultipleSaveStatusRequest.
 * Use `create(CheckMultipleSaveStatusRequestSchema)` to create a new message.
 */
export const CheckMultipleSaveStatusRequestSchema: GenMessage<CheckMultipleSaveStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 25);

/**
 * @generated from message api.v1.collection.CheckMultipleSaveStatusResponse
 */
export type CheckMultipleSaveStatusResponse = Message<"api.v1.collection.CheckMultipleSaveStatusResponse"> & {
  /**
   * @generated from field: repeated api.v1.collection.ItemSaveStatus statuses = 1;
   */
  statuses: ItemSaveStatus[];
};

/**
 * Describes the message api.v1.collection.CheckMultipleSaveStatusResponse.
 * Use `create(CheckMultipleSaveStatusResponseSchema)` to create a new message.
 */
export const CheckMultipleSaveStatusResponseSchema: GenMessage<CheckMultipleSaveStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_collection_collection_service, 26);

/**
 * @generated from enum api.v1.collection.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_EVENT = 1;
   */
  EVENT = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_PRODUCT = 2;
   */
  PRODUCT = 2,

  /**
   * @generated from enum value: ENTITY_TYPE_SERVICE = 3;
   */
  SERVICE = 3,
}

/**
 * Describes the enum api.v1.collection.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_v1_collection_collection_service, 0);

/**
 * @generated from enum api.v1.collection.CollectionVisibility
 */
export enum CollectionVisibility {
  /**
   * @generated from enum value: COLLECTION_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLLECTION_VISIBILITY_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: COLLECTION_VISIBILITY_PUBLIC = 2;
   */
  PUBLIC = 2,
}

/**
 * Describes the enum api.v1.collection.CollectionVisibility.
 */
export const CollectionVisibilitySchema: GenEnum<CollectionVisibility> = /*@__PURE__*/
  enumDesc(file_v1_collection_collection_service, 1);

/**
 * CollectionService manages collections of saved items
 *
 * ==================== COLLECTION MANAGEMENT ====================
 *
 * @generated from service api.v1.collection.CollectionService
 */
export const CollectionService: GenService<{
  /**
   * CreateCollection creates a new collection
   *
   * @generated from rpc api.v1.collection.CollectionService.CreateCollection
   */
  createCollection: {
    methodKind: "unary";
    input: typeof CreateCollectionRequestSchema;
    output: typeof CreateCollectionResponseSchema;
  },
  /**
   * GetCollection retrieves a specific collection
   *
   * @generated from rpc api.v1.collection.CollectionService.GetCollection
   */
  getCollection: {
    methodKind: "unary";
    input: typeof GetCollectionRequestSchema;
    output: typeof CollectionSchema;
  },
  /**
   * UpdateCollection updates an existing collection
   *
   * @generated from rpc api.v1.collection.CollectionService.UpdateCollection
   */
  updateCollection: {
    methodKind: "unary";
    input: typeof UpdateCollectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * DeleteCollection deletes a collection
   *
   * @generated from rpc api.v1.collection.CollectionService.DeleteCollection
   */
  deleteCollection: {
    methodKind: "unary";
    input: typeof DeleteCollectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListCollections retrieves a list of collections
   *
   * @generated from rpc api.v1.collection.CollectionService.ListCollections
   */
  listCollections: {
    methodKind: "unary";
    input: typeof ListCollectionsRequestSchema;
    output: typeof ListCollectionsResponseSchema;
  },
  /**
   * AddItemToCollection adds an item to a collection
   *
   * @generated from rpc api.v1.collection.CollectionService.AddItemToCollection
   */
  addItemToCollection: {
    methodKind: "unary";
    input: typeof AddItemToCollectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * AddItemToCollections adds an item to multiple collections
   *
   * @generated from rpc api.v1.collection.CollectionService.AddItemToCollections
   */
  addItemToCollections: {
    methodKind: "unary";
    input: typeof AddItemToCollectionsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * SaveItem saves an item without specifying collections (virtual "All Saved")
   *
   * @generated from rpc api.v1.collection.CollectionService.SaveItem
   */
  saveItem: {
    methodKind: "unary";
    input: typeof SaveItemRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * UnsaveItem removes an item from all collections and "All Saved"
   *
   * @generated from rpc api.v1.collection.CollectionService.UnsaveItem
   */
  unsaveItem: {
    methodKind: "unary";
    input: typeof UnsaveItemRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * RemoveItemFromCollection removes an item from a collection
   *
   * @generated from rpc api.v1.collection.CollectionService.RemoveItemFromCollection
   */
  removeItemFromCollection: {
    methodKind: "unary";
    input: typeof RemoveItemFromCollectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetCollectionItems retrieves items in a collection
   *
   * @generated from rpc api.v1.collection.CollectionService.GetCollectionItems
   */
  getCollectionItems: {
    methodKind: "unary";
    input: typeof GetCollectionItemsRequestSchema;
    output: typeof GetCollectionItemsResponseSchema;
  },
  /**
   * GetAllSavedItems retrieves all saved items (across all collections) 
   *
   * @generated from rpc api.v1.collection.CollectionService.GetAllSavedItems
   */
  getAllSavedItems: {
    methodKind: "unary";
    input: typeof GetAllSavedItemsRequestSchema;
    output: typeof GetCollectionItemsResponseSchema;
  },
  /**
   * IsSaved checks if an item is saved
   *
   * @generated from rpc api.v1.collection.CollectionService.IsSaved
   */
  isSaved: {
    methodKind: "unary";
    input: typeof IsSavedRequestSchema;
    output: typeof IsSavedResponseSchema;
  },
  /**
   * GetUserCollectionsWithSaveStatus retrieves all user collections with save status for a specific item
   *
   * @generated from rpc api.v1.collection.CollectionService.GetUserCollectionsWithSaveStatus
   */
  getUserCollectionsWithSaveStatus: {
    methodKind: "unary";
    input: typeof GetUserCollectionsWithSaveStatusRequestSchema;
    output: typeof GetUserCollectionsWithSaveStatusResponseSchema;
  },
  /**
   * CheckMultipleSaveStatus checks save status for multiple items at once
   *
   * @generated from rpc api.v1.collection.CollectionService.CheckMultipleSaveStatus
   */
  checkMultipleSaveStatus: {
    methodKind: "unary";
    input: typeof CheckMultipleSaveStatusRequestSchema;
    output: typeof CheckMultipleSaveStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_collection_collection_service, 0);

